import { render } from "./ToolbarColorPicker.vue?vue&type=template&id=65a9c7e4"
import script from "./ToolbarColorPicker.vue?vue&type=script&lang=js"
export * from "./ToolbarColorPicker.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__